import { type ChartData } from '@/common/utils';

export const DEFAULT_CHART_DATA: ChartData = {
  series: {},
  labels: [],
  data: {},
};
